<script>
import { VExpansionPanelHeader } from 'vuetify/lib';
export default VExpansionPanelHeader;
</script>
